import {channelActionType} from './actionType'
import api from '../../../service/apiService'
import {apiUrl} from '../../../constants/apiUrl'


export const loaderActive = (action, dispatch) => {
    dispatch({
      type: channelActionType.loaderSuccess,                
      value: action                
  });     
};

export const getZipCode = async (dispatch, visitId, visitorId, tarcode, zip, appId) =>{
    let url = apiUrl().channelLineupVhoUrl;
    dispatch({ type: channelActionType.loaderSuccess, value: { isLoaderActive: true}})
    await api(url, "POST", getVhoDetails(visitId, visitorId, tarcode, zip, appId))
        .then((response) =>{
            //console.log("getVhoDetails",response,response.data);
            dispatch({
                type: channelActionType.zipCodeSuccess,
                value: response
                
            })
            dispatch({ type: channelActionType.loaderSuccess, value: { isLoaderActive: false}})
        }).catch((error)=>{
            console.log("Zip code error");
            //dispatch({ type: channelActionType.zipCodeSuccess, value: zipcodedata });
        })
}

export const getAllPackage = (dispatch, payload) =>{
    dispatch({ type: channelActionType.loaderSuccess, value: { isLoaderActive: true}})
    let url = apiUrl().channelLineupPackagesUrl;
    let request = { visitid: payload.visitid.toString(), visitorid: payload.visitorid.toString(), appid: payload.appid.toString(), lfa: payload.lfa.toString(), vhoname: payload.vhoname.toString() };
    api(url, "POST", JSON.stringify(request))
    .then((response) =>{
            dispatch({
                type: channelActionType.allPackageSuccess,
                value: response
            })
            dispatch({ type: channelActionType.loaderSuccess, value: { isLoaderActive: false}})
        }).catch((error)=>{
            console.log("Zip code error");
            //dispatch({ type: channelActionType.allPackageSuccess, value: allpackagedata });
        })
}

export const getSearchForChannel = (dispatch, payload) =>{
    // dispatch({ type: channelActionType.loaderSuccess, value: { isLoaderActive: true}})
    let url = apiUrl().channelProgramMasterUrl;
    let request = { visitid: payload.visitid.toString(), visitorid: payload.visitorid.toString(), lfa: payload.lfa.toString(), appid: payload.appid.toString(), programchannelname: payload.programchannelname.toString() };
    api(url, "POST", JSON.stringify(request))
    .then((response) =>{
            dispatch({
                type: channelActionType.searchChannelSuccess,
                value: response
            })
            // dispatch({ type: channelActionType.loaderSuccess, value: { isLoaderActive: false}})
        }).catch((error)=>{
            console.log("Zip code error");
            //dispatch({ type: channelActionType.searchChannelSuccess, value: searchchanneldata });
        })
}

export const getCompareChannel = (dispatch, payload) =>{
    dispatch({ type: channelActionType.loaderSuccess, value: { isLoaderActive: true}})
    let url = apiUrl().channelProgramSearchUrl;
    let request = {
        visitid: payload.visitid.toString(), visitorid: payload.visitorid.toString(), lfa: payload.lfa.toString(), vhoname: payload.vhoname.toString(),
        elkchannelprogram: payload.elkchannelprogram.toString(), name: payload.name.toString(), channelid: payload.channelid.toString(), type: payload.type.toString(),
        programid: payload.programid.toString(), appid: payload.appid.toString()
      }
    api(url, "POST", JSON.stringify(request))
        .then((response) =>{
            dispatch({
                type: channelActionType.compareChannelSuccess,
                value: response
            })
            dispatch({ type: channelActionType.loaderSuccess, value: { isLoaderActive: false}})
        }).catch((error)=>{
            console.log("Zip code error");
            //dispatch({ type: channelActionType.compareChannelSuccess, value: comparechanneldata });
        })
}

export const getPackageByName = (dispatch, payload)=>{
    dispatch({ type: channelActionType.loaderSuccess, value: { isLoaderActive: true}})
    let url = apiUrl().channelLineupPackageView;
    let request = { visitid: payload.visitid.toString(), visitorid: payload.visitorid.toString(), lfa: payload.lfa.toString(), appid: payload.appid.toString(), 
        packageid: payload.packageid.toString(), vhoname: payload.vhoname.toString() };
    api(url, "POST", JSON.stringify(request))
    .then((response)=>{
        dispatch({
            type: channelActionType.packageViewByNameSuccess,
            value: response
        })
        dispatch({ type: channelActionType.loaderSuccess, value: { isLoaderActive: false}})
    }).catch((error)=>{
        console.log("packageByName error");
        //dispatch({type: channelActionType.packageViewByNameSuccess, value: compareViewByChanneldata})
    })
}

const getVhoDetails = (visitid, visitorid, tarcode, zipcode, appid) => {
    let request = { visitid: visitid, visitorid: visitorid, tarcode: tarcode, zip: zipcode, appid: appid };
    return JSON.stringify(request);
  };